import './App.css';
import {useEffect, useState} from 'react';
import {Outlet, useLocation} from 'react-router-dom';

import AutoLoggedOut from './components/autologout/AutoLoggedOut';
import { initGA, logGAPageView } from './googleAnalytics';

const App = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const location = useLocation();

  // Log initial page view in google analytics
  useEffect(() => {
    initGA(); // Initialize GA once when the app loads
    logGAPageView(location.pathname);
  }, []);

  // Log page views in google analytics on route changes
  useEffect(() => {
    logGAPageView(location.pathname);
  }, [location]);






  return (
    <>
      <Outlet
        context={{
          email,
          setEmail,
          password,
          setPassword,
        }}
      />
      <AutoLoggedOut />
    </>
  );
};

export default App;
